
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IPrioridade } from '@/models/Entidades/IPrioridade';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import Servicoprioridade from '@/servicos/ServicoPrioridade';
import { IResposta } from '@/core/models/IResposta';

export default defineComponent({
  name: 'PrioridadeCadastro',
  components: {
    ComunicacaoApi,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicoprioridade = new Servicoprioridade();

    const state = reactive({
      prioridade: {} as IPrioridade,
    });

    async function obterprioridade(codigo:number) {
      appBase.carregando = true;
      state.prioridade = await servicoprioridade.obter(codigo);
      appBase.carregando = false;
    }

    function limparDados() {
      state.prioridade = {} as IPrioridade;
      state.prioridade.codigo = 0;
      state.prioridade.status = true;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigoprioridade = obterCodigoRota();
      if (codigoprioridade > 0) {
        await obterprioridade(codigoprioridade);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da prioridade.');
      if (state.prioridade.codigo === 0) {
        appBase.resposta = await servicoprioridade.incluir(state.prioridade);
      } else {
        appBase.resposta = await servicoprioridade.atualizar(state.prioridade);
      }

      apresentarRespostaRedirecionamento('Prioridades');
    }
    return {
      appBase,
      state,
      salvar,
    };
  },
});
